import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { CategorySelectField } from '../../../components/CategorySelectField';
import { LexOfficeRule } from '../apis/types';

interface LexOfficeBookingRuleProps {
  rule: LexOfficeRule;
  onUpdate: (field: keyof LexOfficeRule, value: string) => void;
  onRemove: () => void;
}

const LexOfficeBookingRule: React.FC<LexOfficeBookingRuleProps> = ({
  rule,
  onUpdate,
  onRemove,
}) => {
  return (
    <div className='flex items-center gap-2'>
      <div className='flex flex-col gap-2 flex-1'>
        <div className='flex items-center gap-2'>
          <span className='text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap'>
            Always books
          </span>
          <input
            type='text'
            value={rule.condition}
            onChange={e => onUpdate('condition', e.target.value)}
            placeholder='Product or keyword'
            className='flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm'
          />
        </div>
        <div className='flex items-center gap-2 justify-end'>
          <span className='text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap'>
            as
          </span>
          <CategorySelectField
            label=''
            value={rule.bookingCategoryId || null}
            onChange={value => onUpdate('bookingCategoryId', value)}
            isEditing={true}
          />
        </div>
      </div>
      <button
        type='button'
        onClick={onRemove}
        className='p-1 text-red-500 hover:text-red-700 transition-colors'
        aria-label='Remove rule'
      >
        <XMarkIcon className='w-5 h-5' />
      </button>
    </div>
  );
};

export default LexOfficeBookingRule;
